import React, { useEffect, useState } from 'react';
import PropTypes                      from 'prop-types';
import Translations                   from '../../utils/Translations';
import Flux                           from '../../flux/Flux';
import Grid2                          from '../Grid2/Grid2';
import ActorTile                      from '../Grid2/Tiles/ActorTile';

const ActorProfileRecommendations = ({actorId}) => {

    const [modelRecommendations, setModelRecommendations] = useState(null);

    useEffect(() => {

        loadModelRecommendations();

        const onRecommendationsChange = (id) => {
            if(actorId !== id) return;
            const recommendations = Flux.Actor.getModelRecommendations(actorId);
            if(recommendations) setModelRecommendations(recommendations);
        };



        Flux.Actor.addModelRecommendationsChangeListener(onRecommendationsChange);

        return () => {
            Flux.Actor.removeModelRecommendationsChangeListener(onRecommendationsChange);
        };

    }, []);

    const loadModelRecommendations = () => {
        const recommendations = Flux.Actor.getModelRecommendations(actorId);

        recommendations ? setModelRecommendations(recommendations) : Flux.Actor.loadModelRecommendations(actorId, 4, true);

    };


	const isRecommendation = Array.isArray(modelRecommendations) && modelRecommendations?.length > 0;

    return ( isRecommendation ? 
		<div className="container-block--actor-grid -margin-bottom-lg -margin-top-sm">
            <div className="media-panel container-block -margin-bottom-lg">
                <div className="context-box--actor-profile clearfix">
                    <h2 className="context-box__title h-left">
                        {Translations.get('ActorProfileRecommendationsHeader')}
                    </h2>
                </div>
                <div id="recommendations-actors-container">
                    <Grid2 
                        noContainerMargins = {true}
                        tileData           = {modelRecommendations}
                        defaultTileClass   = {ActorTile}
                        columns            = {{xs: 2, sm: 2, md: 4, lg: 4}}
                    />
                </div>
            </div>
        </div> 
	: null );
};

ActorProfileRecommendations.propTypes = {
	actorId: PropTypes.number.isRequired,
};

export default ActorProfileRecommendations;
